/**
 * 2D top-down plan preview of the small-power layout.
 * Pure presentational — no state, no API calls.
 */
export default function SmallPowerPlan({ project, layout }) {
  const L = project.length_in, W = project.width_in;
  const pad = 12, w = 720, h = w * (W / L);
  const sx = (x) => pad + (x / L) * (w - 2 * pad);
  const sy = (y) => h - pad - (y / W) * (h - 2 * pad);

  return (
    <div className="border border-white/10 bg-[#050608] p-3 mt-4" data-testid="small-power-plan">
      <div className="label-tag mb-2">// Preview · top-down plan</div>
      <svg viewBox={`0 0 ${w} ${h}`} className="w-full bg-[#0a0d12] border border-white/5">
        {/* Room outline */}
        <rect x={pad} y={pad} width={w - 2 * pad} height={h - 2 * pad} fill="none" stroke="#00E5FF" strokeWidth="1.5" />
        {/* Equipment */}
        {(project.equipment_list || []).map((it) => {
          const p = it.position || {};
          if (p.x_in === undefined) return null;
          const wi = p.w_in || it.length_in || 24;
          const hi = p.h_in || it.width_in  || 18;
          return (
            <rect key={it.id}
              x={sx(p.x_in)} y={sy(p.y_in + hi)}
              width={sx(p.x_in + wi) - sx(p.x_in)} height={sy(p.y_in) - sy(p.y_in + hi)}
              fill="#3C82B4" fillOpacity="0.35" stroke="#3C82B4" />
          );
        })}
        {/* Receptacles */}
        {layout.receptacles.map((r) => (
          <g key={r.id} data-testid={`plan-recep-${r.id}`}>
            <circle cx={sx(r.x_in)} cy={sy(r.y_in)} r={4.5} fill="#22c55e" stroke="#0a0d12" strokeWidth="1" />
            <text x={sx(r.x_in) + 6} y={sy(r.y_in) - 6} fontSize="9" fill="#22c55e" fontFamily="monospace">{r.tag}</text>
          </g>
        ))}
        {/* Luminaires */}
        {layout.luminaires.map((l) => (
          <g key={l.id} data-testid={`plan-lum-${l.id}`}>
            <rect x={sx(l.x_in) - 6} y={sy(l.y_in) - 4} width="12" height="8" fill="#FFCC00" fillOpacity="0.7" stroke="#FFCC00" />
            <text x={sx(l.x_in) + 8} y={sy(l.y_in) + 3} fontSize="9" fill="#FFCC00" fontFamily="monospace">{l.tag}</text>
          </g>
        ))}
        {/* Switches */}
        {layout.switches.map((s) => (
          <g key={s.id} data-testid={`plan-sw-${s.id}`}>
            <path d={`M ${sx(s.x_in)-4} ${sy(s.y_in)} L ${sx(s.x_in)+4} ${sy(s.y_in)} M ${sx(s.x_in)} ${sy(s.y_in)-4} L ${sx(s.x_in)} ${sy(s.y_in)+4}`} stroke="#00E5FF" strokeWidth="1.6" />
            <text x={sx(s.x_in) + 6} y={sy(s.y_in) + 12} fontSize="9" fill="#00E5FF" fontFamily="monospace">{s.tag}</text>
          </g>
        ))}
      </svg>
      <div className="flex gap-4 mt-2 text-[10px] font-mono text-gray-400">
        <span><span className="inline-block w-3 h-3 rounded-full bg-[#22c55e] mr-1 align-middle" /> Receptacle</span>
        <span><span className="inline-block w-3 h-2 bg-[#FFCC00] mr-1 align-middle" /> Luminaire</span>
        <span><span className="text-[#00E5FF] mr-1">+</span> Switch</span>
        <span><span className="inline-block w-3 h-3 bg-[#3C82B4]/40 border border-[#3C82B4] mr-1 align-middle" /> Equipment</span>
      </div>
    </div>
  );
}
